import { navigate } from 'gatsby';
import isEmpty from 'lodash/isEmpty';
import { useEffect } from 'react';
import { AppDispatch } from '../redux/configureStore';

export const useLinkLogin = (isSignedIn: boolean, linkLoginRedirect: AppDispatch) => {
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const hash = params.get('hash');
    const path = params.get('path');
    params.delete('hash');
    (async () => {
      if (hash && !isSignedIn) {
        const response = await linkLoginRedirect(hash, path);
        if (path) {
          if (!isEmpty(response.payload.redirectTo)) {
            navigate(response.payload.redirectTo + '?' + params.toString());
            return;
          } else {
            navigate('/' + '?' + params.toString());
            return;
          }
        }
      } else {
        if (path && !isEmpty(path)) {
          try {
            const sanitizedUrl = new URL(path, window.location.origin);
            navigate(sanitizedUrl.pathname + sanitizedUrl.search + '?' + params.toString());
            return;
          } catch (error) {
            console.error(error);
            navigate('/' + '?' + params.toString());
            return;
          }
        }
      }
      if (window.location.pathname == '/l') {
        navigate('/');
      }
    })();
  }, []);
};
